"use client";

import {
    Box,
    Grid,
    Typography,
    Button,
    Chip,
    Stack,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Image from "next/image";
import { useTranslations } from "next-intl";

/* Animations */
const WelcomeSection = () => {
    const ACCENT = "#F15859";
    const t = useTranslations("ServicePage.welcome_section");

    return (
        <Box
            component="section"
            sx={{
                background: "#132c4b",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                py: { xs: 3, md: 6 },
            }}
        >
            <Grid container columnSpacing={2} rowSpacing={2} sx={{ maxWidth: "lg", mx: "auto", px: { xs: 2.5, md: 0 }, justifyContent: "center", alignItems: "center" }}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Box>
                        <Chip
                            label={t('chip')}
                            sx={{
                                bgcolor: ACCENT,
                                color: "white",
                                fontWeight: 700,
                                mb: 3,
                            }}
                        />
                        <Typography
                            component="h1"
                            sx={{
                                fontSize: { xs: "24px", md: "36px" },
                                fontWeight: 800,
                                lineHeight: 1.1,
                                mb: 2,
                            }}
                        >
                            {t('title')}
                        </Typography>
                        <Typography
                            sx={{
                                color: "rgba(255,255,255)",
                                mb: 2,
                                maxWidth: "90%",
                                fontSize: "14px",
                            }}
                            dangerouslySetInnerHTML={{ __html: t.raw('description') }}
                        />
                        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                            <Button
                                variant="contained"
                                size="large"
                                endIcon={<ArrowForwardIcon />}
                                sx={{
                                    bgcolor: ACCENT,
                                    fontWeight: 700,
                                    px: 4,
                                    py: 1.6,
                                    textTransform: "none",
                                    "&:hover": { bgcolor: "#F15859" },
                                }}
                                href="/contact"
                            >
                                {t('button')}
                            </Button>
                        </Stack>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Box>
                        <Image
                            src="/images/service-cover.png"
                            alt="AirXpress Service Overview"
                            width={1280}
                            height={874}
                            priority={true}
                            sizes="(max-width: 900px) 100vw, 50vw"
                            style={{
                                objectFit: "cover",
                                borderRadius: "1rem",
                                width: "100%",
                                height: "auto",
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default WelcomeSection;